import React from 'react';
import { BrainIcon, ShoppingBagIcon, TargetIcon, PlugIcon, BarChartIcon, CheckCircleIcon } from 'lucide-react';
export function Solution() {
  const capabilities = [{
    icon: TargetIcon,
    title: 'Dietary needs',
    description: 'Pulls from nutrition or EHR data to identify ideal food targets',
    color: 'text-blue-600',
    bgColor: 'bg-blue-100'
  }, {
    icon: ShoppingBagIcon,
    title: 'Shopping reality',
    description: "Compares against what's actually available in grocery or delivery platforms",
    color: 'text-green-600',
    bgColor: 'bg-green-100'
  }, {
    icon: BrainIcon,
    title: 'Behavioral fit',
    description: 'Optimizes for affordability, preference, and purchase likelihood',
    color: 'text-orange-600',
    bgColor: 'bg-orange-100'
  }];
  const steps = [{
    icon: PlugIcon,
    title: 'Integrate via API or SDK',
    description: "Plug Lola into your platform's existing recommendation or ordering flow"
  }, {
    icon: BrainIcon,
    title: 'Match and optimize',
    description: 'Lola evaluates millions of food alternatives using real-world data (price, nutrition, and purchasing behavior)'
  }, {
    icon: BarChartIcon,
    title: 'Deliver and measure',
    description: 'Track healthy substitution rates, purchase adherence, and impact on outcomes'
  }];
  return <section className="py-20 bg-gradient-to-b from-green-50 to-white" data-id="element-158">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-159">
        {/* Meet Lola */}
        <div className="text-center mb-16" data-id="element-160">
          <div className="inline-flex items-center gap-2 bg-green-100 text-green-600 px-4 py-2 rounded-full font-semibold mb-6" data-id="element-161">
            <BrainIcon className="w-5 h-5" data-id="element-162" />
            The Solution
          </div>
          <h2 className="text-4xl font-bold text-gray-900 mb-4" data-id="element-163">Meet Lola</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto mb-12" data-id="element-164">
            Lola is an AI engine that personalizes food recommendations based
            on:
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 mb-20" data-id="element-165">
          {capabilities.map((capability, index) => <div key={index} className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all hover:-translate-y-1" data-id="element-166">
              <div className={`w-16 h-16 rounded-2xl ${capability.bgColor} ${capability.color} flex items-center justify-center mb-6`} data-id="element-167">
                <capability.icon className="w-8 h-8" data-id="element-168" />
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-3" data-id="element-169">
                {capability.title}
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-170">
                {capability.description}
              </p>
            </div>)}
        </div>

        <div className="bg-gradient-to-r from-green-500 to-emerald-600 rounded-3xl p-10 text-white text-center shadow-2xl mb-20" data-id="element-171">
          <h3 className="text-3xl font-bold mb-4" data-id="element-172">The result?</h3>
          <p className="text-xl text-green-50 max-w-3xl mx-auto" data-id="element-173">
            Smart substitutions and tailored baskets that patients actually
            choose<br data-id="element-174" />without compromising health goals
          </p>
        </div>

        {/* How It Works */}
        <div className="text-center mb-16" data-id="element-175">
          <h2 className="text-4xl font-bold text-gray-900 mb-4" data-id="element-176">
            How It Works
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-177">
            Three simple steps to transform your platform's nutrition
            recommendations
          </p>
        </div>

        <div className="flex gap-8" data-id="element-178">
          {steps.map((step, index) => <div key={index} className="relative flex-1 h-full" data-id="element-179">
              <div className="bg-white h-full rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow border-2 border-gray-100" data-id="element-180">
                <div className="absolute -top-4 -right-4 w-12 h-12 bg-green-500 text-white rounded-full flex items-center justify-center font-bold text-xl shadow-lg" data-id="element-181">
                  {index + 1}
                </div>

                <div className="w-16 h-16 rounded-2xl bg-green-100 text-green-600 flex items-center justify-center mb-6" data-id="element-182">
                  <step.icon className="w-8 h-8" data-id="element-183" />
                </div>

                <h3 className="text-2xl font-bold text-gray-900 mb-3" data-id="element-184">
                  {step.title}
                </h3>
                <p className="text-gray-600 leading-relaxed" data-id="element-185">
                  {step.description}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}